import React, { useState } from 'react';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { UiButton, OverlayLoader } from './ui';
import { theme } from 'antd';
import { useModal } from '@ebay/nice-modal-react';
import { toast } from "react-toastify";
import { instance } from "./axios";


const exportToPDF = (columns, data, title, company, company_desc, heading1, heading2, heading3, topleft, topright, lastbold, action, type, staff, showLoader) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.getWidth();
  const centerX = pageWidth / 2;
  var startY = 10;
  doc.setFontSize(12);
  if (company) {
    doc.setFontSize(15);
    doc.text(company, centerX, startY, { align: 'center' });
    startY = startY + 10
  }
  if (company_desc) {
    doc.setFontSize(12);
    doc.text(company_desc, centerX, startY, { align: 'center' });
    startY = startY + 10
  }

  if (heading1) {
    doc.setFontSize(16);
    doc.text(heading1, centerX, startY, { align: 'center' });
    startY = startY + 10
  }
  if (heading2) {
    doc.setFontSize(12);
    doc.text(heading2, centerX, startY, { align: 'center' });
    startY = startY + 10
  }
  if (heading3) {
    doc.setFontSize(10);
    doc.text(heading3, centerX, startY, { align: 'center' });
    startY = startY + 10
  }

  if (topleft) {
    doc.setFontSize(11);
    doc.text(topleft, 14, startY, { align: 'left' });

  }

  if (topright) {
    doc.setFontSize(10);
    doc.text(topright, 196, startY, { align: 'right' });

  }

  if (topleft || topright) {
    startY = startY + 5

  }

  // Define the table column names
  const tableColumn = columns.map(col => col.title);

  // Define the table rows
  const tableRows = data.map(item => columns.map(col => item[col.dataIndex]));



  // Map column alignment settings
  const columnStyles = columns.reduce((styles, col, index) => {
    styles[index] = {};

    // Handle alignment if specified
    if (col.align) {
      styles[index].halign = col.align;
    }

    // Handle width if specified, otherwise default to 'auto'
    styles[index].cellWidth = col.width || 'auto';

    return styles;
  }, {});

  // Add the table to the PDF
  doc.autoTable({
    startY: startY,
    head: [tableColumn],
    body: tableRows,
    theme: 'grid',

    willDrawCell: (data) => {
      // Check if this is the last row
      const isLastRow = data.row.index === data.table.body.length - 1;
      if (isLastRow && lastbold) {
        // Set font style to bold for the last row
        doc.setFont(undefined, 'bold');
      }
    },
    // Reset the font style to normal after drawing the table
    didDrawCell: (data) => {
      const isLastRow = data.row.index === data.table.body.length - 1;
      if (isLastRow && lastbold) {
        doc.setFont(undefined, 'normal');
      }
    },


    didParseCell: function (data) {
      const totalRows = data.table.body.length; // Total number of rows in the table
      const rowIndex = data.row.index;

      // Ensure multi-line text is split and processed correctly
      if (typeof data.cell.raw === 'string') {
        // Split text by newline
        data.cell.text = data.cell.raw.split('\\n').map(line => line.trim()); // Trim leading/trailing spaces
      }
      const column = columns[data.column.index];
      if (rowIndex === totalRows - 1) {
        if (column && column.colspan) {
          data.cell.colSpan = column.colspan;
          const nextColumns = columns.slice(data.column.index + 1, data.column.index + column.colspan);
          nextColumns.forEach((_, i) => {
            data.row.cells[data.column.index + i + 1].text = ''; // Clear text in the merged cells
          });
        }
      }



      if (data.section === 'body' && column.items == 1) {
        const doc = data.doc;
        const lines = data.cell.raw.split('\\n');
        const cellWidth = column.width - 5;

        data.cell.text = lines.map(line => {
          const [desc, qty] = line.split('||');

          if (qty !== undefined) {
            // Trim text to avoid extra spaces
            const descText = desc.trim();
            const qtyText = qty.trim();

            // Get the width of each text
            const descWidth = doc.getTextWidth(descText);
            const qtyWidth = doc.getTextWidth(qtyText);

            // Calculate available width in the cell
            const availableWidth = cellWidth - qtyWidth;


            // Adjust padding to align description and quantity
            const padding = Math.max(0, availableWidth - descWidth);

            // Create the formatted line with padding
            return `${descText}${' '.repeat(Math.floor(padding))}${qtyText}`;
          } else {
            // Return line if there's no quantity
            return line;
          }
        });
      }

    },
    columnStyles: columnStyles,
    headStyles: {
      fillColor: [223, 234, 252],
      textColor: 0,
      fontStyle: 'bold',
      valign: 'middle', // vertical align
    },
  });

  // Save the PDF
  //doc.save(title+'.pdf');
  if (action == 'send') {

    showLoader(true)
    const pdfBlob = doc.output('blob');

    // Prepare the form data
    const formData = new FormData();
    formData.append('file', pdfBlob, 'report.pdf');
    formData.append('id', staff);
    formData.append('type', type);



    instance({
      method: "post",
      url: "/send_report",
      data: formData,
    })
      .then(function (response) {
        showLoader(false)
        if (response.data.status == 'success') {
          toast(response.data.msg, { type: "success" });
        }
        if (response.data.status == 'error') {
          toast(response.data.msg, { type: "error" });
        }

      })
      .catch(function (response) { });


  } else {
    window.open(doc.output('bloburl', title + '.pdf'), '_blank');
  }
};

const ExportPDFButton = ({ columns, data, title, company, company_desc, heading1, heading2, heading3, className, topleft, topright, lastbold, action, type }) => {
  const [loader, showLoader] = useState(false);

  const shareModal = useModal('report_send');

  const sendReport = (type) => {
    shareModal.show({ type }).then((res) => {
      exportToPDF(columns, data, title, company, company_desc, heading1, heading2, heading3, topleft, topright, lastbold, action, type, res.staff.value, showLoader);
    });
  }
  return (
    <>
      <OverlayLoader visible={loader} />
      <UiButton className={`btn btn-outline-primary ${data.length == 0 && 'disabled'} ${className}`} onClick={() => (action == 'send' ? sendReport(type) : exportToPDF(columns, data, title, company, company_desc, heading1, heading2, heading3, topleft, topright, lastbold))} title={action == 'send' ? 'Send Report' : 'PDF'} />

    </>
  )

};

export default ExportPDFButton;
